/* tslint:disable */
/* eslint-disable */
/**
 * Expert
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 *
 * @export
 * @interface InlineResponse200
 */
export interface InlineResponse200 {
  /**
   *
   * @type {number}
   * @memberof InlineResponse200
   */
  earns?: number;
  /**
   *
   * @type {MeEarnsDetailedCustomer}
   * @memberof InlineResponse200
   */
  customer?: MeEarnsDetailedCustomer | null;
}
/**
 *
 * @export
 * @interface InlineResponse2001
 */
export interface InlineResponse2001 {
  /**
   *
   * @type {number}
   * @memberof InlineResponse2001
   */
  earned?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2001
   */
  purchasedCount?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2001
   */
  involvedCount?: number;
}
/**
 *
 * @export
 * @interface InlineResponse2002
 */
export interface InlineResponse2002 {
  /**
   *
   * @type {number}
   * @memberof InlineResponse2002
   */
  id?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2002
   */
  created_at?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2002
   */
  price?: number;
  /**
   *
   * @type {MePurchasesCustomer}
   * @memberof InlineResponse2002
   */
  customer?: MePurchasesCustomer | null;
  /**
   *
   * @type {MePurchasesSpace}
   * @memberof InlineResponse2002
   */
  space?: MePurchasesSpace | null;
}
/**
 *
 * @export
 * @interface InlineResponse2003
 */
export interface InlineResponse2003 {
  /**
   *
   * @type {number}
   * @memberof InlineResponse2003
   */
  subscribed_at?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2003
   */
  subscriptionPrice?: number | null;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2003
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2003
   */
  name?: string;
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse2003
   */
  isAvatar?: boolean;
  /**
   *
   * @type {MeEarnsDetailedCustomerAvatar}
   * @memberof InlineResponse2003
   */
  avatar?: MeEarnsDetailedCustomerAvatar | null;
}
/**
 *
 * @export
 * @interface MeEarnsDetailedCustomer
 */
export interface MeEarnsDetailedCustomer {
  /**
   *
   * @type {number}
   * @memberof MeEarnsDetailedCustomer
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof MeEarnsDetailedCustomer
   */
  name?: string;
  /**
   *
   * @type {MeEarnsDetailedCustomerAvatar}
   * @memberof MeEarnsDetailedCustomer
   */
  avatar?: MeEarnsDetailedCustomerAvatar | null;
}
/**
 *
 * @export
 * @interface MeEarnsDetailedCustomerAvatar
 */
export interface MeEarnsDetailedCustomerAvatar {
  /**
   *
   * @type {number}
   * @memberof MeEarnsDetailedCustomerAvatar
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof MeEarnsDetailedCustomerAvatar
   */
  url?: string;
}
/**
 *
 * @export
 * @interface MePurchasesCustomer
 */
export interface MePurchasesCustomer {
  /**
   *
   * @type {number}
   * @memberof MePurchasesCustomer
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof MePurchasesCustomer
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof MePurchasesCustomer
   */
  description?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof MePurchasesCustomer
   */
  isAvatar?: boolean;
  /**
   *
   * @type {MeEarnsDetailedCustomerAvatar}
   * @memberof MePurchasesCustomer
   */
  avatar?: MeEarnsDetailedCustomerAvatar | null;
}
/**
 *
 * @export
 * @interface MePurchasesSpace
 */
export interface MePurchasesSpace {
  /**
   *
   * @type {number}
   * @memberof MePurchasesSpace
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof MePurchasesSpace
   */
  title?: string;
  /**
   *
   * @type {number}
   * @memberof MePurchasesSpace
   */
  price?: number;
  /**
   *
   * @type {string}
   * @memberof MePurchasesSpace
   */
  type?: MePurchasesSpaceTypeEnum;
  /**
   *
   * @type {string}
   * @memberof MePurchasesSpace
   */
  status?: MePurchasesSpaceStatusEnum;
  /**
   *
   * @type {string}
   * @memberof MePurchasesSpace
   */
  payment_type?: MePurchasesSpacePaymentTypeEnum;
  /**
   *
   * @type {MePurchasesSpaceConfig}
   * @memberof MePurchasesSpace
   */
  config?: MePurchasesSpaceConfig | null;
  /**
   *
   * @type {MeEarnsDetailedCustomerAvatar}
   * @memberof MePurchasesSpace
   */
  cover?: MeEarnsDetailedCustomerAvatar | null;
}

export const MePurchasesSpaceTypeEnum = {
  Post: 'post',
  Live: 'live',
  Challenge: 'challenge',
  Trailer: 'trailer',
  Channel: 'channel',
} as const;

export type MePurchasesSpaceTypeEnum = typeof MePurchasesSpaceTypeEnum[keyof typeof MePurchasesSpaceTypeEnum];
export const MePurchasesSpaceStatusEnum = {
  Draft: 'draft',
  Published: 'published',
} as const;

export type MePurchasesSpaceStatusEnum = typeof MePurchasesSpaceStatusEnum[keyof typeof MePurchasesSpaceStatusEnum];
export const MePurchasesSpacePaymentTypeEnum = {
  FixedPrice: 'fixed_price',
  FixedPriceSubscribersOnly: 'fixed_price_subscribers_only',
  SubscribersOnly: 'subscribers_only',
  Free: 'free',
  MonthlyPrice: 'monthly_price',
} as const;

export type MePurchasesSpacePaymentTypeEnum =
  typeof MePurchasesSpacePaymentTypeEnum[keyof typeof MePurchasesSpacePaymentTypeEnum];

/**
 *
 * @export
 * @interface MePurchasesSpaceConfig
 */
export interface MePurchasesSpaceConfig {
  /**
   *
   * @type {MePurchasesSpaceConfigChallenge}
   * @memberof MePurchasesSpaceConfig
   */
  challenge?: MePurchasesSpaceConfigChallenge | null;
}
/**
 *
 * @export
 * @interface MePurchasesSpaceConfigChallenge
 */
export interface MePurchasesSpaceConfigChallenge {
  /**
   *
   * @type {number}
   * @memberof MePurchasesSpaceConfigChallenge
   */
  finishTimestamp?: number | null;
}

/**
 * MeApi - axios parameter creator
 * @export
 */
export const MeApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    meEarnsDetailedGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/me/earns/detailed`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Получение суммы заработка эксперта (за всё время) <br /><br /> <b>Authentication:</b> required
     * @summary Получение суммы заработка эксперта (за всё время)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    meEarnsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/me/earns`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    mePurchasesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/me/purchases`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Список подписок на эксперта, с указанием стоимости подписки <br /><br /> <b>Authentication:</b> required
     * @summary Список подписок на эксперта, с указанием стоимости подписки
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    meSubscriptionsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/me/subscriptions`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {string} [period]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    meTransactionsGet: async (period?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/me/transactions`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (period !== undefined) {
        localVarQueryParameter['period'] = period;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * MeApi - functional programming interface
 * @export
 */
export const MeApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = MeApiAxiosParamCreator(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async meEarnsDetailedGet(
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InlineResponse200>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.meEarnsDetailedGet(options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Получение суммы заработка эксперта (за всё время) <br /><br /> <b>Authentication:</b> required
     * @summary Получение суммы заработка эксперта (за всё время)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async meEarnsGet(
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2001>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.meEarnsGet(options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async mePurchasesGet(
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InlineResponse2002>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.mePurchasesGet(options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Список подписок на эксперта, с указанием стоимости подписки <br /><br /> <b>Authentication:</b> required
     * @summary Список подписок на эксперта, с указанием стоимости подписки
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async meSubscriptionsGet(
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InlineResponse2003>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.meSubscriptionsGet(options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {string} [period]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async meTransactionsGet(
      period?: string,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.meTransactionsGet(period, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * MeApi - factory interface
 * @export
 */
export const MeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = MeApiFp(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    meEarnsDetailedGet(options?: any): AxiosPromise<Array<InlineResponse200>> {
      return localVarFp.meEarnsDetailedGet(options).then(request => request(axios, basePath));
    },
    /**
     * Получение суммы заработка эксперта (за всё время) <br /><br /> <b>Authentication:</b> required
     * @summary Получение суммы заработка эксперта (за всё время)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    meEarnsGet(options?: any): AxiosPromise<InlineResponse2001> {
      return localVarFp.meEarnsGet(options).then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    mePurchasesGet(options?: any): AxiosPromise<Array<InlineResponse2002>> {
      return localVarFp.mePurchasesGet(options).then(request => request(axios, basePath));
    },
    /**
     * Список подписок на эксперта, с указанием стоимости подписки <br /><br /> <b>Authentication:</b> required
     * @summary Список подписок на эксперта, с указанием стоимости подписки
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    meSubscriptionsGet(options?: any): AxiosPromise<Array<InlineResponse2003>> {
      return localVarFp.meSubscriptionsGet(options).then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {string} [period]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    meTransactionsGet(period?: string, options?: any): AxiosPromise<object> {
      return localVarFp.meTransactionsGet(period, options).then(request => request(axios, basePath));
    },
  };
};

/**
 * MeApi - object-oriented interface
 * @export
 * @class MeApi
 * @extends {BaseAPI}
 */
export class MeApi extends BaseAPI {
  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MeApi
   */
  public meEarnsDetailedGet(options?: AxiosRequestConfig) {
    return MeApiFp(this.configuration)
      .meEarnsDetailedGet(options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * Получение суммы заработка эксперта (за всё время) <br /><br /> <b>Authentication:</b> required
   * @summary Получение суммы заработка эксперта (за всё время)
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MeApi
   */
  public meEarnsGet(options?: AxiosRequestConfig) {
    return MeApiFp(this.configuration)
      .meEarnsGet(options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MeApi
   */
  public mePurchasesGet(options?: AxiosRequestConfig) {
    return MeApiFp(this.configuration)
      .mePurchasesGet(options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * Список подписок на эксперта, с указанием стоимости подписки <br /><br /> <b>Authentication:</b> required
   * @summary Список подписок на эксперта, с указанием стоимости подписки
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MeApi
   */
  public meSubscriptionsGet(options?: AxiosRequestConfig) {
    return MeApiFp(this.configuration)
      .meSubscriptionsGet(options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {string} [period]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MeApi
   */
  public meTransactionsGet(period?: string, options?: AxiosRequestConfig) {
    return MeApiFp(this.configuration)
      .meTransactionsGet(period, options)
      .then(request => request(this.axios, this.basePath));
  }
}
